import React, { FunctionComponent } from "react";

const FlagWarningIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/social-medias-rewards-rating/flags/flag-warning
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0.75 23.25V0.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0.75 20.2929L3.904 19.3229C5.21051 18.9207 6.58781 18.8018 7.94392 18.9743C9.30003 19.1467 10.6037 19.6065 11.768 20.3229C12.9046 21.0222 14.1743 21.4772 15.4964 21.659C16.8184 21.8408 18.1638 21.7454 19.447 21.3789L22.434 20.5259C22.669 20.4586 22.8758 20.3166 23.023 20.1214C23.1702 19.9262 23.2499 19.6884 23.25 19.4439V3.63691C23.2498 3.46283 23.2093 3.29117 23.1316 3.13539C23.0539 2.97962 22.9412 2.84398 22.8022 2.73913C22.6632 2.63428 22.5019 2.56308 22.3308 2.53111C22.1596 2.49915 21.9834 2.50729 21.816 2.55491L19.447 3.23191C18.1638 3.59842 16.8184 3.69381 15.4964 3.51201C14.1743 3.3302 12.9046 2.87518 11.768 2.17591C10.6037 1.45949 9.30003 0.999702 7.94392 0.827257C6.58781 0.654812 5.21051 0.773675 3.904 1.17591L0.75 2.14491"
      ></path>
      <path
        stroke="currentColor"
        d="M12 16.5C11.7929 16.5 11.625 16.3321 11.625 16.125C11.625 15.9179 11.7929 15.75 12 15.75"
      ></path>
      <path
        stroke="currentColor"
        d="M12 16.5C12.2071 16.5 12.375 16.3321 12.375 16.125C12.375 15.9179 12.2071 15.75 12 15.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 12.75V6.75"
      ></path>
    </svg>
  );
};

export default FlagWarningIcon;
